import { render, staticRenderFns } from "./invigilatorAccess.vue?vue&type=template&id=c68a2b88&scoped=true&"
import script from "./invigilatorAccess.vue?vue&type=script&lang=js&"
export * from "./invigilatorAccess.vue?vue&type=script&lang=js&"
import style0 from "./invigilatorAccess.vue?vue&type=style&index=0&id=c68a2b88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68a2b88",
  null
  
)

export default component.exports